export const CHUNK_RETRY_PARAM = "__chunk_retry__";

const CHUNK_LOAD_ERROR_PATTERNS: RegExp[] = [
  /Failed to fetch dynamically imported module/i,
  /Importing a module script failed/i,
  /Loading chunk [\w-]+ failed/i,
  /Failed to asynchronously load chunk/i,
  /ChunkLoadError/i,
];

interface ErrorMessageParams {
  error: unknown;
}

interface BuildChunkRetryUrlParams {
  currentUrl: string;
  retryValue?: string;
}

interface ChunkRetryCleanupUrlParams {
  currentUrl: string;
}

const normalizeErrorMessage = ({ error }: ErrorMessageParams): string => {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  return "";
};

export const isChunkLoadError = ({ error }: ErrorMessageParams): boolean => {
  const message = normalizeErrorMessage({ error });

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

export const buildChunkRetryUrl = ({
  currentUrl,
  retryValue = String(Date.now()),
}: BuildChunkRetryUrlParams): string => {
  const url = new URL(currentUrl);
  url.searchParams.set(CHUNK_RETRY_PARAM, retryValue);

  return url.toString();
};

export const getChunkRetryCleanupUrl = ({
  currentUrl,
}: ChunkRetryCleanupUrlParams): string | null => {
  const url = new URL(currentUrl);

  if (!url.searchParams.has(CHUNK_RETRY_PARAM)) {
    return null;
  }

  url.searchParams.delete(CHUNK_RETRY_PARAM);

  return url.toString();
};

export const retryCurrentDocument = () => {
  window.location.replace(
    buildChunkRetryUrl({ currentUrl: window.location.href }),
  );
};
